module.exports = __webpack_public_path__ + "img/default.27b9408d.png";